import {QUERY_KEYS as AUTH_QUERY_KEYS} from '@/features/authentication/queries/keys'
import {QUERY_KEYS as CHAT_QUERY_KEYS} from '@/features/chat/queries/keys'
import {MonthlySupportError, PaymentMethodUrls} from '@/features/guest-payments/types'
import {ROUTE_MESSAGE_CENTER} from '@/utilities/constants/routeNames'
import {LocalStorageManager} from '@/utilities/localStorage'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosResponse} from 'axios'
import {subscribeToHostV3} from '../services/recurringGift.http'
import {SubscribeToHostRequestV3} from '../types'
import {MUTATION_KEYS, QUERY_KEYS} from './keys'
import {QUERY_KEYS as MEMBERSHIP_QUERY_KEYS} from '@/features/configure-membership-plans/edit-configure-membership-plans-modal/queries/keys'
import {selectSetPaymentMethodUrls} from '@/store/selectors'
import {useRootStore} from '@/store'

export const useSubscribeToHostV3 = () => {
    const queryClient = useQueryClient()
    const setPaymentMethodUrls = useRootStore(selectSetPaymentMethodUrls)
    return useMutation<AxiosResponse, MonthlySupportError, SubscribeToHostRequestV3>({
        mutationKey: [MUTATION_KEYS.subscribeToHost],
        mutationFn: subscribeToHostV3,
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: [CHAT_QUERY_KEYS.fetchChannelDetailsV3]})
            queryClient.invalidateQueries({queryKey: [CHAT_QUERY_KEYS.fetchChannels]})
            queryClient.invalidateQueries({queryKey: [AUTH_QUERY_KEYS.user]})
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.subscribedHostsV3]})
            queryClient.invalidateQueries({queryKey: [MEMBERSHIP_QUERY_KEYS.membership_plans]})
        },
        onSettled: (_, error) => {
            if (error?.response?.status === 303) setPaymentMethodUrls(error?.response?.data.url as PaymentMethodUrls)
            LocalStorageManager.paymentStartLocation.set(location.pathname ?? ROUTE_MESSAGE_CENTER)
        }
    })
}
